export default __webpack_public_path__ + "static/media/inside.8044f36f.svg";